import { Button } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

import { Check } from "@/components/icons";
import { DIETARY_TAGS } from "@/lib/menu";
import type { DietaryTag } from "@/lib/types";

/**
 * Toggle row of dietary tags for a menu item (vegetarian, gluten-free,
 * …). Output order is canonical regardless of click order. Shared by
 * the admin menu editor and the buyer setup wizard.
 */
export function DietaryChips({
  value,
  onChange,
}: {
  value: DietaryTag[];
  onChange: (tags: DietaryTag[]) => void;
}) {
  const { t } = useTranslation();
  const toggle = (key: DietaryTag) => {
    const next = value.includes(key)
      ? value.filter((tag) => tag !== key)
      : [...value, key];
    onChange(DIETARY_TAGS.map((d) => d.key).filter((k) => next.includes(k)));
  };
  return (
    <div className="flex flex-wrap gap-1.5">
      {DIETARY_TAGS.map(({ key, labelKey }) => {
        const active = value.includes(key);
        return (
          <Button
            key={key}
            type="button"
            variant={active ? "default" : "outline"}
            size="sm"
            className="h-7 gap-1 rounded-full px-2.5 text-xs"
            onClick={() => toggle(key)}
            aria-pressed={active}
          >
            {active && <Check className="h-3 w-3" />}
            {t(labelKey)}
          </Button>
        );
      })}
    </div>
  );
}
